export const SEARCH_TEXT = "Search Hotels";
export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
export const SEARCH_VR_TEXT = "Search Vacation Rentals";
